import { useState } from "react";
import { Sheet } from "./ui";
import { Icon } from "./icons";

const canNative = () => typeof navigator !== "undefined" && !!navigator.share;

/** Share an authenticated link (never audio files): native sheet (AirDrop/Bluetooth/…) + explicit channels. */
export function ShareSheet({ title, text, url, onClose }) {
  const [copied, setCopied] = useState(false);
  const msg = `${text}\n${url}`;
  const native = async () => {
    try { await navigator.share({ title, text, url }); onClose(); }
    catch (err) { if (err?.name !== "AbortError") console.error("Partilha nativa falhou", err); }
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 2500); }
    catch (err) { console.error("Cópia falhou", err); window.prompt("Copie o link:", url); }
  };
  const links = [
    { k: "email", icon: "mail", label: "Email", href: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(msg)}` },
    { k: "whatsapp", icon: "chatbubble", label: "WhatsApp", href: `https://wa.me/?text=${encodeURIComponent(msg)}` },
    { k: "sms", icon: "sms", label: "SMS", href: `sms:?&body=${encodeURIComponent(msg)}` },
  ];
  const item = { display: "flex", alignItems: "center", gap: 12, padding: 14, color: "inherit", textDecoration: "none", cursor: "pointer", width: "100%", textAlign: "left" };
  return (
    <Sheet title="Partilhar" onClose={onClose} testid="share-sheet">
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {canNative() ? (
          <button className="card" style={item} onClick={native} data-testid="share-native">
            <Icon name="share" size={18} color="var(--brand-primary)" /><span style={{ flex: 1 }}>Partilhar pelo dispositivo<div className="t-hint">AirDrop, Bluetooth, Mensagens e outras apps</div></span>
          </button>
        ) : null}
        {links.map((l) => (
          <a key={l.k} className="card" style={item} href={l.href} target="_blank" rel="noopener noreferrer" data-testid={`share-${l.k}`}>
            <Icon name={l.icon} size={18} color="var(--brand-primary)" /><span>{l.label}</span>
          </a>
        ))}
        <button className="card" style={item} onClick={copy} data-testid="share-copy">
          <Icon name="link" size={18} color="var(--brand-primary)" /><span>{copied ? "Ligação copiada" : "Copiar ligação"}</span>
        </button>
        <div className="t-hint" style={{ marginTop: 4 }}>
          É partilhada apenas uma ligação. Quem a abrir tem de iniciar sessão e só vê as músicas a que tem acesso; os ficheiros áudio nunca são enviados.
          {!canNative() ? " AirDrop/Bluetooth aparecem quando o dispositivo suporta partilha nativa." : ""}
        </div>
      </div>
    </Sheet>
  );
}
